<template>
  <b-nav-item @click="updateModeLayoutByUser">
    <feather-icon
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
    />
  </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BNavItem,
  },
  methods: {
    updateModeLayoutByUser() {
      this.skin = this.isDark ? 'light' : 'dark'
      localStorage.setItem('template-app-custom-user', true)
      this.$store.dispatch('auth/setConfigAccountUser', { skin: this.skin })
    },
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },
}
</script>
